/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Route.`
};

const en_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `No itinerary.`
};

const es_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `No hay itinerario.`
};

const fr_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun itinéraire.`
};

const it_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun itinerario.`
};

const nl_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `Geen route.`
};

const pt_route__route_selector_no_road = /** @type {(inputs: {}) => string} */ () => {
	return `Sem itinerário.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__route_selector_no_road(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__route_selector_no_road", locale)
	if (locale === "de") return de_route__route_selector_no_road(inputs)
	if (locale === "en") return en_route__route_selector_no_road(inputs)
	if (locale === "es") return es_route__route_selector_no_road(inputs)
	if (locale === "fr") return fr_route__route_selector_no_road(inputs)
	if (locale === "it") return it_route__route_selector_no_road(inputs)
	if (locale === "nl") return nl_route__route_selector_no_road(inputs)
	return pt_route__route_selector_no_road(inputs)
};